import {Component, inject, OnInit} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {Divider} from 'primeng/divider';
import {PlayerProfile} from '../../../model/player-profile';
import {PlayerSessionService} from '../../../service/player-session.service';
import {DomSanitizer} from '@angular/platform-browser';
import {Panel} from 'primeng/panel';
import {PrimeTemplate} from 'primeng/api';

@Component({
  selector: 'app-player-profile-help',
  imports: [
    TranslatePipe,
    Divider,
    Panel,
    PrimeTemplate
  ],
  templateUrl: './player-profile-help.component.html',
  styleUrl: './player-profile-help.component.scss'
})
export class PlayerProfileHelpComponent implements OnInit
{
  private playerSessionService = inject(PlayerSessionService);
  public sanitizer = inject(DomSanitizer);

  playerProfile: PlayerProfile;
  freshdeskSrc: string;
  ticketSend: boolean;

  ngOnInit(): void
  {
    this.playerProfile = this.playerSessionService.playerProfileObject;
    this.initForm();
  }

  private initForm(): void
  {
    if (!this.playerProfile)
      return;

    // const userMail = this.authenticationService.userMail;
    // const mail = userMail || this.mandant?.email;

    // https://partnersupport.freshworks.com/en/support/solutions/articles/154064-pre-populating-feedback-widget-form
    const url = 'https://2k-dartsoftware.freshdesk.com/widgets/feedback_widget/new?&widgetType=embedded&formTitle=Kontakt' +
      '&helpdesk_ticket[requester]=' + encodeURIComponent(this.playerProfile.mail ?? '') +
      '&helpdesk_ticket[typ]=TYP' +
      // '&helpdesk_ticket[typ]=Spielerprofil' +
      '&helpdesk_ticket[type]=TYPE' +
      // '&helpdesk_ticket[type]=Spielerprofil' +
      // '&helpdesk_ticket[group_id]=103000429366' +
      '&helpdesk_ticket[custom_field][cf_mandanten_key_2599410]=0' +
      '&helpdesk_ticket[custom_field][cf_spielernummer_2599410]=' + (this.playerProfile?.playerNumber ?? '') +
      // '&helpdesk_ticket[custom_field][cf_telefon_2599410]=' + (this.mandant?.phone ?? '') +
      '&helpdesk_ticket[subject]=Frage zu Spielerprofil';

    // cf_spielernummer_2599410
    // helpdesk_ticket_group_id
    // s2id_helpdesk_ticket_group_id

    // '&helpdesk_ticket[description]=' + this.getTextInfos();
    // [customer-id]
    console.log('url: ' + url);
    // @ts-ignore
    this.freshdeskSrc = this.sanitizer.bypassSecurityTrustResourceUrl(url);

    /*this.form = this.formBuilder.group({
      mandant: [{value: this.mandant.name, disabled: true}],
      // mandantKey: new UntypedFormControl(mandant.mandantKey, Validators.required),
      phone: new UntypedFormControl(this.mandant.phone, Validators.required),
      mail: new UntypedFormControl(this.mandant.email, Validators.required),
      title: new UntypedFormControl('', Validators.required),
      text: new UntypedFormControl('', Validators.required),
    });*/
  }
}
